<template>
  <div class="bg-white radius-medium pd-medium br-1px br-grey-transp-15">
    <div class="d-flex flex-v-center flex-justify-between mn-b-regular">
      <div class="d-flex flex-v-center gap-small">
        <component :is="brandIcon" v-if="brandIcon" />
        <div v-else class="pd-l-small pd-r-small pd-t-thin pd-b-thin radius-small bg-light">
          <p class="p-small fw-medium t-dark">{{ brandLabel }}</p>
        </div>
        <div>
          <p class="p-regular fw-medium">{{ primaryLine }}</p>
          <p v-if="expiryLine" class="p-small t-grey">{{ expiryLine }}</p>
        </div>
      </div>
      <span
        v-if="method.isDefault"
        class="pd-l-small pd-r-small pd-t-thin pd-b-thin radius-small bg-main t-white p-small"
      >
        {{ $t('paymentMethods.default') }}
      </span>
    </div>

    <div class="d-flex gap-small">
      <button
        v-if="!method.isDefault"
        class="pd-l-small pd-r-small pd-t-thin pd-b-thin p-small radius-small bg-light t-dark cursor-pointer"
        @click="$emit('setDefault', method._id)"
      >
        {{ $t('paymentMethods.makeDefault') }}
      </button>
      <button
        class="pd-l-small pd-r-small pd-t-thin pd-b-thin p-small radius-small bg-red t-white cursor-pointer"
        @click="confirmRemove"
      >
        {{ $t('paymentMethods.remove') }}
      </button>
    </div>
  </div>
</template>

<script setup>
import { computed, getCurrentInstance } from 'vue';
import IconVisa from '../icons/IconVisa.vue';
import IconMastercard from '../icons/IconMastercard.vue';
import IconMir from '../icons/IconMir.vue';
import IconMaestro from '../icons/IconMaestro.vue';
import IconAmex from '../icons/IconAmex.vue';
import IconJcb from '../icons/IconJcb.vue';
import IconUnionpay from '../icons/IconUnionpay.vue';
import IconCardGeneric from '../icons/IconCardGeneric.vue';

const props = defineProps({
  method: { type: Object, required: true },
});

const emit = defineEmits(['delete', 'setDefault']);

const { proxy } = getCurrentInstance();

// Маппинг brand-кода из платёжного шлюза на SVG-иконку бренда.
const BRAND_ICON_MAP = {
  visa: IconVisa,
  mastercard: IconMastercard,
  mir: IconMir,
  maestro: IconMaestro,
  amex: IconAmex,
  american_express: IconAmex,
  jcb: IconJcb,
  unionpay: IconUnionpay,
};

const brandIcon = computed(() => {
  if (props.method.type !== 'bank_card') return null;
  const brand = (props.method.details?.brand || '').toLowerCase();
  return BRAND_ICON_MAP[brand] || IconCardGeneric;
});

const brandLabel = computed(() => {
  const type = props.method.type;
  if (type === 'bank_card') {
    const brand = props.method.details?.brand;
    return brand ? brand.toUpperCase() : proxy.$t(`paymentMethods.types.${type}`);
  }
  return proxy.$t(`paymentMethods.types.${type}`) || type;
});

const primaryLine = computed(() => {
  const last4 = props.method.details?.last4;
  if (props.method.type === 'bank_card' && last4) {
    return proxy.$t('paymentMethods.cardMasked', { last4 });
  }
  return proxy.$t(`paymentMethods.types.${props.method.type}`) || props.method.type;
});

const expiryLine = computed(() => {
  if (props.method.type !== 'bank_card') return '';
  const m = props.method.details?.expiryMonth;
  const y = props.method.details?.expiryYear;
  if (!m || !y) return '';
  const month = String(m).padStart(2, '0');
  const year = String(y).slice(-2);
  return proxy.$t('paymentMethods.expires', { month, year });
});

function confirmRemove() {
  if (typeof window !== 'undefined' && !window.confirm(proxy.$t('paymentMethods.confirmRemove'))) {
    return;
  }
  emit('delete', props.method._id);
}
</script>
